const PATH_PREFIX = '/admin/company/:companyID';

export default [
  {
    name: 'company.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'company.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'company.profile',
    path: `${PATH_PREFIX}/profile`,
  },
  {
    name: 'company.profile.commercial_practice',
    path: `${PATH_PREFIX}/profile/commercial_practice`,
  },
  {
    name: 'company.profile.trade_capability',
    path: `${PATH_PREFIX}/profile/trade_capability`,
  },
  {
    name: 'company.shipping_methods',
    path: `${PATH_PREFIX}/shipping_methods`,
  },
  {
    name: 'company.shipping_methods_details',
    path: `${PATH_PREFIX}/shipping_methods/:shipping_methodID/details`,
  },
  {
    name: 'company.payment_methods',
    path: `${PATH_PREFIX}/payment_methods`,
  },
  {
    name: 'company.payment_method_details',
    path: `${PATH_PREFIX}/payment_method/:docID/details`,
  },
  {
    name: 'company.keywords',
    path: `${PATH_PREFIX}/keywords/:type`,
  },
  {
    name: 'company.keyword',
    path: `${PATH_PREFIX}/keywords/:type/:docID`,
  },
  {
    name: 'company.contacts',
    path: `${PATH_PREFIX}/contacts`,
  },
  {
    name: 'company.branches',
    path: `${PATH_PREFIX}/branches`,
  },
  {
    name: 'company.media.logo',
    path: `${PATH_PREFIX}/media/logo`,
  },
  {
    name: 'company.media.banner',
    path: `${PATH_PREFIX}/media/banner`,
  },
  {
    name: 'company.media.banner.details',
    path: `${PATH_PREFIX}/media/banner/:docID`,
  },
  {
    name: 'company.media.advertisement',
    path: `${PATH_PREFIX}/media/advertisement`,
  },
  {
    name: 'company.media.catalogue',
    path: `${PATH_PREFIX}/media/catalogue`,
  },
  {
    name: 'company.departments',
    path: `${PATH_PREFIX}/teams/departments`,
  },
  {
    name: 'company.department',
    path: `${PATH_PREFIX}/teams/departments/:departmentID`,
  },
  {
    name: 'company.employees',
    path: `${PATH_PREFIX}/teams/employees`,
  },
  {
    name: 'company.employee',
    path: `${PATH_PREFIX}/teams/employees/:employeeID`,
  },
  {
    name: 'company.page.main_page',
    path: `${PATH_PREFIX}/page/main_page`,
  },
  {
    name: 'company.configuration',
    path: `${PATH_PREFIX}/configuration`,
  },
];
